module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.totalPage > 0) ? _c('p', {
    staticClass: "pager-wrapper"
  }, [_c('span', {
    class: {
      'disabled': _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        return _vm.go(_vm.currentPage - 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('previous')))]), _vm._v(" "), _c('span', {
    class: {
      'current-page': _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        return _vm.go(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pages[0] > 2),
      expression: "pages[0] > 2"
    }]
  }, [_vm._v("···")]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('span', {
      class: {
        'current-page': _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          return _vm.go(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pages[_vm.pages.length - 1] < _vm.totalPage - 1),
      expression: "pages[pages.length - 1] < totalPage - 1"
    }]
  }, [_vm._v("···")]), _vm._v(" "), (_vm.totalPage > 1) ? _c('span', {
    class: {
      'current-page': _vm.currentPage === _vm.totalPage
    },
    on: {
      "click": function($event) {
        return _vm.go(_vm.totalPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.totalPage))]) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      'disabled': _vm.currentPage === _vm.totalPage
    },
    on: {
      "click": function($event) {
        return _vm.go(_vm.currentPage + 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-091c4b3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pager/Index.vue
// module id = 1259
// module chunks = 1